<template>
  <MultipleChoicesDropdown
    title="Round stage"
    :value="value"
    :show-clear-all="false"
    :single-choice="singleChoice"
    :search-enabled="false"
    :choices="choices"
    @change="$emit('change', $event)"
  />
</template>

<script>
import ROUND_STAGES from 'services/round-stages'

export default {
  props: {
    singleChoice: { type: Boolean, default: true },
    value: {},
  },
  computed: {
    choices: () => ROUND_STAGES,
  },
}
</script>
